import cx from "classnames";
import React from "react";
import style from "./newVoteWidgetsListItem.module.css";

type NewVoteWidgetsListItemProps = {
    value: string;
    name: string;
    selectCount: number;
    candidateCount: number;
    onSelect: (val: boolean) => void;
};

export function NewVoteWidgetsListItem(props: NewVoteWidgetsListItemProps) {
    const disabled = props.candidateCount < 1;
    const checked = !disabled && props.candidateCount === props.selectCount;

    return (
        <div
            className={cx(
                style.newVoteWidgetsListItem,
                { [style.disabled]: disabled },
                disabled ? "disabledWidgetCheckbox" : "",
            )}
        >
            <div className={style.newVoteWidgetsListItemLabel}>
                <input
                    id={props.value}
                    className={cx(style.newVoteWidgetsListItemCheckbox, "baseCheckbox")}
                    disabled={disabled}
                    name={props.value}
                    value={props.value}
                    checked={checked}
                    type="checkbox"
                    onChange={() => props.onSelect(!checked)}
                />
                <label className={disabled ? "" : style.label} htmlFor={props.value}>
                    {props.name}
                </label>
            </div>
            <p className={style.newVoteWidgetsListItemCount}>
                {props.selectCount} / {props.candidateCount}
            </p>
        </div>
    );
}
